<div class="section">
  <div class="number">{{index + 1}})</div>
  <div class="account">
    <div class="account-name" [recordField]="'lines.accountId'">{{getAccountName()}}</div>
    <div class="track" [recordField]="'lines.taxId'">{{getTaxRateName()}}</div>
    <div class="track" [recordField]="'lines.tracking'" *ngIf="trackingCategories?.length > 0">{{getTrackingCategory(invoiceLine.trackingOptions[0])}}</div>
    <div class="track" [recordField]="'lines.tracking'" *ngIf="trackingCategories?.length > 1">{{getTrackingCategory(invoiceLine.trackingOptions[1])}}</div>
    <div class="track" *ngIf="getClassName()">{{getClassName()}}</div>
    <div class="details" [recordField]="'lines.description'" *ngIf="invoiceLine?.description">{{invoiceLine?.description}}</div>
  </div>
  <div class="amount">
    <div class="total" [recordField]="'lines.amount'">{{invoiceLine.subTotal | number}}</div>
    <div class="taxTotal">{{invoiceLine.totalTax | number}}</div>
  </div>
</div>
